export default __webpack_public_path__ + "static/media/campfire_mobile.d3e98772.svg";